





















import {Component, Prop, Vue} from 'vue-property-decorator';
import OrderPanel from '@/components/orders/OrderPanel.vue';
import { HistoryOrdersList } from '@/model/history/HistoryOrdersList';
import { EventBus } from '@/helpers/EventBus';
import dayjs from 'dayjs';

@Component({
  components: {OrderPanel}
})
export default class HistoryResultsList extends Vue {

    @Prop({}) ordersList: HistoryOrdersList;

    private openedCards: string[] = [];

    isCardOpened(cardId: string): boolean {
        return this.openedCards.includes(cardId);
    }

    toggleCardFolding(cardId: string) {
        if (this.isCardOpened(cardId)) {
            this.openedCards = this.openedCards.filter(id => id !== cardId);
        } else {
            this.openedCards.push(cardId);
        }
    }

    get orders() {
        return this.ordersList ? this.ordersList.orders : [];
    }

    get nbOrders() {
        return this.ordersList ? this.ordersList.orders.length : 0;
    }

    get startDate() {
        const startDate = (this.ordersList && this.ordersList.filters) ? this.ordersList.filters.startDate : dayjs();
        
        return startDate.format('DD/MM/YYYY');
    }

    get endDate() {
        const endDate = (this.ordersList && this.ordersList.filters) ? this.ordersList.filters.endDate : dayjs();
        
        return endDate.format('DD/MM/YYYY');
    }

    exportHistory() {
        EventBus.$emit(EventBus.HISTORY_EXPORT, null);
    }
}
